// extracted by mini-css-extract-plugin
export default {"largeScreenWidth":"70","mediumScreenWidth":"38","projectDetailsWidth":"46"};